//@flow
import React from 'react';
import MediaQuery from 'react-responsive';
import Query from '../../Utils/query';

export default function OfficeVideo() {
  return (
    <div className="office-video">
      <div className="row">
        <MediaQuery query={Query.toEm({ min: 641 })}>
          <iframe
            title="NatureBox Office Snacks"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/y7BBRZJEUkg"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          >
          </iframe>
        </MediaQuery>
        <MediaQuery query={Query.toEm({ max: 640 })}>
          <iframe
            title="NatureBox Office Snacks"
            width="340"
            height="200"
            src="https://www.youtube.com/embed/y7BBRZJEUkg"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen={true}
          >
          </iframe>
        </MediaQuery>
      </div>
    </div>
  );
}
